import {ContractTypeService} from '../services/contract-type.service';

export const DictionaryListConstants = {
  contract_type: ContractTypeService
};
